/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import routes from 'src/routes'
window.routes = routes;

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()

const context = require.context("../src/controllers", true, /\.js$/)
window.Stimulus.load(definitionsFromContext(context))

import {searchFormFlex} from 'src/listings/search_form_flex.js';
window.searchFormFlex = searchFormFlex;

document.addEventListener('searchFormFlex:reloadData', ({detail: { serializedForm = null, isBasicsChange = false, dispatchTheEvent = true, serializedAnnotations = '' }}) => {
  if(serializedAnnotations && serializedAnnotations.length > 0){
    try{
      const annotations = JSON.parse(serializedAnnotations);
      window.androidAppAnnotations = annotations;
    } catch(e){
      window.androidAppAnnotations = [];
    }
  }

  if(serializedForm){
    searchFormFlex.reloadData(serializedForm, isBasicsChange, dispatchTheEvent);
  }
});

/**
 * Show the filter button when the Android App's Filter Panel Closes
 */
document.addEventListener('nativeApp:closeFilterPanel', () => {
  document.querySelector('.sub-nav__toggle--left')?.classList?.remove('active');
});


/**
 * Hide the filter button when the Android App's Filter Panel opens
 */
document.addEventListener('nativeApp:openFilterPanel', () => {
  document.querySelector('.sub-nav__toggle--left')?.classList?.add('active');
});


document.addEventListener('nativeApp:closeLDP', () => {
  $('.ldp-overlay').trigger('click');
});

// Emulating the changeTemplate function from the template_controller.js
document.addEventListener('nativeApp:quickSearchIdChanged', ({detail: {quickSearchId}}) => {
  const currentPath = window.location.pathname;
  // Look for the id in the current path...
  const regex = /\/quick_searches\/\d{26}/g;

  // ...and replace it with the id associated with the selected template
  const newPath = currentPath.replace(regex,'/quick_searches/' + quickSearchId);
  
  window.location.href = newPath;
});

/**
 * Basically emulate what `search_filters_controller.js -> drawShapes` does
 */
document.addEventListener('nativeApp:drawOnMapButtonPressed', () => {
  if ($('.c-flex-content--map').length > 0) {
    // Map mode is already in place.  Pop up the 'Draw A Shape' menu
    dispatchEvent(new CustomEvent('map:drawShapes'));
  } else {
    // Enter map mode and tell the map controller to pop up the 'Draw A Shape' menu
    dispatchEvent(new CustomEvent('subnav:displayMapAndDrawShapes'));
  }
});


